import { render, staticRenderFns } from "./AccountIdCardContent.vue?vue&type=template&id=2ac07444&scoped=true"
import script from "./AccountIdCardContent.vue?vue&type=script&lang=js"
export * from "./AccountIdCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac07444",
  null
  
)

export default component.exports